import { render } from "./Spacer.vue?vue&type=template&id=e06dc900&ts=true"
import script from "./Spacer.vue?vue&type=script&lang=ts"
export * from "./Spacer.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__